import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { IPricingToMatch } from '../interfaces/IPricingToMatch';

const PRICING_TO_MATCH_PROPERTY: IPricingToMatch[] = [
  {
    id: 1,
    title: 'SIMPLE',
    facets: '1-4 Facets',
    roofOnly: 25,
    complete: 50,
    image: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        src="../assets/images/pricing_simple.png"
        alt="simple pricing"
        objectFit="contain"
      />
    ),
  },
  {
    id: 2,
    title: 'AVERAGE',
    facets: '5-10 Facets',
    roofOnly: 50,
    complete: 75,
    image: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        src="../assets/images/pricing_average.png"
        alt="average pricing"
        objectFit="contain"
      />
    ),
  },
  {
    id: 3,
    title: 'COMPLEX',
    facets: '11+ Facets',
    roofOnly: 75,
    complete: 99,
    image: (
      <StaticImage
        quality={100}
        placeholder="blurred"
        src="../assets/images/pricing_complex.png"
        alt="complex pricing"
        objectFit="contain"
      />
    ),
  },
];

export default PRICING_TO_MATCH_PROPERTY;
